


<mat-card>
    <mat-card-header>
      <mat-card-title>Finish</mat-card-title>
    </mat-card-header>


    <mat-card-content class="m-t-1">

        @if(!allComponentsReady) {
        <div class="d-flex justify-content-center">
            <mat-spinner diameter="60"></mat-spinner>
        </div>
        }
        <app-feedback #feedbackForm
            [model]="model"
            [formTypes]="formTypes"
            [style.visibility]="allComponentsReady ? 'visible' : 'hidden'"
            (formReady)="onFeedbackFormReady($event)"
        >
        </app-feedback>
        <app-data-protection #dataProtectionForm
            [model]="model"
            [style.visibility]="allComponentsReady ? 'visible' : 'hidden'"
            (formReady)="onDataProtectionFormReady($event)"
        >
        </app-data-protection>
   

 
    </mat-card-content>
</mat-card>
    
